<template>
<div>
                                 
  <v-container         
    class="pt-0 ml-0 mr-0 pr-0 debugOutline3"
    >
                               
    <HomeLastLook
      :audioDisabled = audioDisabled
      />

    <v-card class="mt-1 pl-1 pr-1">

        <v-layout>
          <v-flex xs12  class="align-content-center light-blue--text text--lighten-4 tSmaller pt-1" offset-xs2 offset-sm3 offset-lg2>
            Look for Tee Times on one more of these Courses
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs6 sm3 lg2>
              <v-checkbox v-model="selectedCourses" label="Cim" value="Cimarron" class="tBlue"></v-checkbox>
          </v-flex>
          <v-flex xs6 sm3 lg2>
              <v-checkbox v-model="selectedCourses" label="Des" value="Desert"></v-checkbox>
          </v-flex>
          <v-flex xs6 sm3 lg2>
              <v-checkbox v-model="selectedCourses" label="Nor" value="North"></v-checkbox>
          </v-flex>
          <v-flex xs6 sm3 lg2>
              <v-checkbox v-model="selectedCourses" label="Sou" value="South"></v-checkbox>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs12  class="align-content-center light-blue--text text--lighten-4 tSmaller pt-0" offset-xs3 offset-lg2>
            Look for Tee Times in this range of times
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 sm4 md2 lg2 class="mb-1 pl-1 align-content-center text-xs-center">
                  <v-text-field
                    v-model="range0"
                    class="mb-1 mt-0 pt-0 ml-2 pr-1 "
                    hide-details
                    single-line
                    style="width: 120px;"
                    height=30
                    readonly solo rounded dense
                  ></v-text-field>      
          </v-flex>
          <v-flex xs12 sm12 md9 lg9 class="ml-1 mr-1 mb-0 text-xs-center">
                <v-range-slider
                  v-model="range"
                  :max="max"
                  :min="min"
                  hide-details
                  class="align-center"
                >
                </v-range-slider>       
          </v-flex>
          <v-flex xs12 sm4 md2 lg2 class="text-xs-center mb-1">
                  <v-text-field
                    v-model="range1"
                    class="mb-1 mt-0 pt-0 pl-1"
                    hide-details
                    single-line
                    style="width: 120px;"
                    height=30
                    readonly solo rounded dense
                  ></v-text-field>      
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs12  class="align-content-center light-blue--text text--lighten-4 tSmaller pt-0" offset-xs3 offset-lg2>
            Show openings based on players booked
          </v-flex>
        </v-layout>

        <v-layout v-if="$store.state.settings.show123Players">
          <v-flex xs6 sm3 md2>
              <v-checkbox 
                v-model="show0Players" 
                label="empty"                
                false-value=false
                true-value=true
                >
                <!--  @change="changeOpeningsPlayers" -->
              </v-checkbox>
          </v-flex>
          <v-flex xs6 sm3 md2>
              <v-checkbox 
                v-model="show1Player" 
                label="singles"
                false-value=false
                true-value=true
                >
              </v-checkbox>
          </v-flex>
          <v-flex xs6 sm3 md2>
              <v-checkbox 
                v-model="show2Players" 
                label="2-somes"                
                false-value=false
                true-value=true
                >
              </v-checkbox>
          </v-flex>
          <v-flex xs6 sm3 md2>
              <v-checkbox 
                v-model="show3Players" 
                label="3-somes"                
                false-value=false
                true-value=true
                >
                <!--  @change="changeOpeningsPlayers" -->
              </v-checkbox>
          </v-flex>
          <v-flex xs6 sm3 md2>
              <v-checkbox 
                v-model="show4Players" 
                label="4-somes"                
                false-value=false
                true-value=true
                >
              </v-checkbox>
          </v-flex>
        </v-layout>

    </v-card>
                                        
    <v-card class="mt-1 pl-1 pr-1 pt-1 pb-1">

        <v-layout wrap class="pt-1">
          <v-flex xs12 md4 class="tBlue tSmall" >
            <span v-if="filteredOpenings.length>0">
              </span>{{actualOpenings.length}} Opening<span v-if="filteredOpenings.length!=1">s</span> 
              on {{ shortenDate(this.$store.getters.selectedDate) }}
              <!--{{$store.state.sniffing.teeSheetDate}} 
              actualOpenings = {{actualOpenings.length}} -->
          </v-flex>

          <v-flex xs12 md8> &nbsp;
            <span class="tSmallest" v-if="active" v-html="hoverOpening(filteredOpenings[activeItem])"></span>
          </v-flex>
        </v-layout>

      <v-layout wrap class="mt-2">
            <v-flex 
              v-for="(item, index) in filteredOpenings" 
              :key=index
              class='holeCard tSmaller tC hoverOpening '
              v-bind:class="classObject3(item)"  
              @mouseover="mouseOver(index)"
              @mouseout="mouseOut" 
              >
                {{ shortTime(item.time) }}<br>
                {{ abbrev(item.course) }}
                {{ item.hole }}  <span class="players tSmaller">  {{ blankIfZero(item.players) }}  </span>  
            </v-flex>
            <!-- classObject3() this creates the style based on the course and diff state -->

            <v-flex pt-1 ml-1>
              <v-btn 
                x-small 
                height=32px
                @click="playersToggle" 
                >
                #
              </v-btn>
            </v-flex>

      </v-layout>

          <v-alert
            :value="alert"
            type="info"
            transition="scale-transition"
            outlined dense
            class="mt-1 tSmall"
          >
            This will clear the change indications, and delete the tee times no longer available.

            <v-btn 
              class="ml-1"
              x-small
              color="info"
              @click="alert = !alert"
              >
              Cancel
            </v-btn>

            <v-btn
              class="ml-2"
              x-small
              color="primary"
              @click="clearChangeUI"
              >
              OK
            </v-btn>

                      <!--
                      Added timestamp
                      Deleted timestamp
                      Booked approx x minutes ago
                      Became Avail approx ...
                      -->

          </v-alert>

    </v-card>

    <v-card class="mt-1 pl-1 pr-1 pt-1 pb-1">

    <HomeHistory
      :selectedDate2 = this.$store.getters.selectedDate2
      :selectedCourses = selectedCourses
      :tF = tF
      :tF2= tF2
      />

    </v-card>

    <v-card class="mt-1 pl-1 pr-1 pt-1 pb-1">

        <v-layout>
          <!--
          <v-flex xs4  class="align-content-center tBlue tSmallest pt-4" >
            <a href='https://sungrand.chelseareservations.com/golf/ReviewTeeSheet.aspx' target='_chelsea'>LINK TO CHELSEA</a>
          </v-flex>
          -->
          <v-flex xs1 sm1 lg1 
            class="align-content-center tBlue tSmallest pt-4"
            v-if="$vuetify.breakpoint.smAndDown"
            >
            <!--
            // MOBILE: https://sungrand.chelseareservations.com/mobile/golf/MobileMenu.aspx
            -->
            <v-btn 
              href="https://sungrand.chelseareservations.com/mobile/golf/ReviewTeeSheetm.aspx" target="_chelseaM"
              dark small text
              color="blue lighten-3"
              >
              <v-icon>mdi-golf-tee</v-icon>
            </v-btn>
          </v-flex>

          <v-flex xs3 sm2 lg1 
            class="align-content-center tBlue tSmallest pt-4" 
            v-if="$vuetify.breakpoint.mdAndUp"
            >
            <v-btn 
              href="https://sungrand.chelseareservations.com/golf/ReviewTeeSheet.aspx" target="_chelsea"
              dark x-small text
              color="blue lighten-2"
              >
              <v-icon>mdi-golf-tee</v-icon> CHELSEA
            </v-btn>
          </v-flex>

          <v-flex xs3 sm6 class="align-content-center tBlue tSmallest pt-5" >
            <!-- 024371, 047871, 003611, 062501, 013361, 003241 -->
            <v-btn 
              x-small
              class="ml-2"
              @click="zoomChelsea=!zoomChelsea"  
              >
              Numbers
            </v-btn>
          </v-flex>

          <v-spacer></v-spacer>

          <v-flex xs2 lg1 
            class="align-content-center tBlue tSmallest pt-4" 
            v-if="this.$store.state.settings.showTextMessages"
            >
            <v-btn 
              class="mx-2" 
              dark x-small text
              color="blue"
              @click="testSMS"
              >
              <v-icon dark>mdi-cellphone-message mdi-18px</v-icon>Test SMS
            </v-btn>
          </v-flex>

          <v-flex xs1  
            class="align-content-center tBlue tSmallest pt-4" 
            v-if="this.$store.state.settings.showDiffsViaAudio"
            >
            <v-btn 
              class="mx-5" 
              dark x-small text
              color="red lighten-2"
              @click="audioOff"
              v-bind:class="audioOffClass()"
              >
              <v-icon dark>mdi-volume-off mdi-18px</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs2 sm1 md1 
            class="align-content-center tBlue tSmallest pt-4" 
            v-if="this.$store.state.settings.showDiffsViaAudio"
            >
            <v-btn 
              class="mx-5" 
              dark x-small text
              color="grey"
              @click="audioOn"
              v-bind:class="audioOnClass()"
              >
              <v-icon dark>mdi-volume-plus  mdi-18px</v-icon>
            </v-btn>
          </v-flex>

          <v-flex xs3 lg2 
            class="align-content-center tBlue tSmallest pt-4" 
            v-if="this.$store.state.settings.showDiffsViaAudio"
            >
            <v-btn 
              class="mx-2" 
              dark x-small text
              color="amber"
              @click="playAudio"
              >
              <v-icon dark>mdi-volume-low  mdi-18px</v-icon>Test<span v-if="$vuetify.breakpoint.smAndUp">Alert Volume</span>
            </v-btn>
          </v-flex>

        </v-layout>

        <span v-if="filteredOpenings.length>0">
          {{playAudioComputed}}
        </span>

    </v-card>

    <v-card v-if="zoomChelsea">
          <ul>
              <li v-for="(value, v, index) in myChelseaHelpers"
                      :key=index
                      class='noBullet '
                      >
                <v-layout>
                  <v-flex xs8 sm8 md5 class='noBullet tLarger pt-2 mb-2'
>
                  {{value.name}} 
                  </v-flex>
                  <v-flex xs4 sm3 md2 class='noBullet tLarger2 mb-2'
>
                  {{value.num}}
                  </v-flex>
                          
                </v-layout>
              </li>
          </ul>
    </v-card>

  </v-container>
  </div>

</template>

<script>

// includes chelseaDateToYYYY_MM_DD()
import { exampleMixin } from '../mixins/exampleMixin.js' // eslint-disable-line no-unused-vars

import HomeLastLook from './HomeLastLook.vue'
//import pace_Audio1c4 from '../js/pace_Audio1c4.js'
import HomeHistory from './HomeHistory.vue'

export default {
  name: 'home',

  mixins: [exampleMixin],

  components: { HomeLastLook, HomeHistory },

  data: () => ({

    zoomChelsea: false,

    myPlayerNames: [

      "MARK ADAM",
      "WILLIAM AUTREY",
      "MICHAEL BAKER",
      "LLOYD BLANUSA",
      "THOMAS BOWER",
      "BRIAN BOYLE",
      "MIKE BRUCATO",
      "ED BUSS",
      "WARREN CENTER",
      "BRENT CHOZEN",
      "TOM COMMERS",
      "DARYL DELICH",
      "DAN DURKIN",
      "STEVE FRANSEN",
      "JAMES HACKENBERG",
      "JIM HACKENBERG",
      "BILL HARALDSON",
      "BOB JOHNSON",
      "BILL LASATER",
      "LANCE MACFARLAND",
      "MIKE MONAHAN",
      "JERRY MOORE",
      "RON MILLER",
      "GORDON PECK",
      "ED PERI",
      "JAMES PERKIN",
      "BERNIE RIHN",
      "KEITH RUBIS",
      "ROYCE SCHWEIZER",
      "VERN SELINDH",
      "BOB SIEGEL",
      "PAUL SPERRY",
      "HAROLD STEELE",
      "ALLEN STEFANKO",
      "BRUCE SWEDELL",
      "ALEX VOLZ",
      "PETE ZOGRAFOS",
      //"LASATER",
      //"JOHNSON"
      // chelsea helper names

      "JEANNETTE BOWER",    // 062501
      "TERRY HARALDSON",    // 003241
      "GAYLE JOHNSON",      // 003611
      "JUDITH LASATER",     // 024371
      "JEANNIE PECK",       // 047871
      "ROSE MARIE PERKIN",  // 013361
      "PAMELA RUBIS",       // 064881
      "POLLY MARMADUKE",    // 071341


    ],

    myChelseaHelpers: [
      {name:"JEANNETTE BOWER", num:"062501"},
      {name:"TERRY HARALDSON", num:"003241"},
      {name:"GAYLE JOHNSON",  num:"003611"},
      {name:"JUDITH LASATER",  num:"024371"},
      {name:"JEANNIE PECK",   num:" 047871"},
      {name:"ROSE MARIE PERKIN", num:"013361"},
      {name:"PAMELA RUBIS", num:"064881"},
      {name:"POLLY MARMADUKE", num:"071341"},

    ],


    myPlayerNamesNot: [

      "LINDA AUTREY",
      "BECKY BRUCATO",
      "LINDA CENTER",
      "GAYLE JOHNSON",
      "RON JOHNSON",
      "TERRY JOHNSON",
      "KEN JOHNSON",
      "DON JOHNSON",
      "DAVE JOHNSON",
      "THOM JOHNSON",
      "D L JOHNSON",
      "FLOYD JOHNSON",
      "JIM JOHNSON",

    ],

    alert: false,
    showDiffs: false,
    lastSMStimestamp: 0,

    active: false,
    activeItem: 0,

    localData: "Chelsea Tee Sheet",
    sniffDT: "",
    // time slider variable
    min: 0,
    max: 72,  // for 8am to 5pm
    //max: 80,  // for 7am to 5pm
    slider: 35,
    range: [24, 44],  // 11:00 to 01:30    MAKE THIS A SETTING
    //range: [0, 72],   // 07:00 to 05:00

    selectedCourses: [],
    //selectedCourses: ['Cimarron','Desert','North','South'],     MAKE THESE SETTINGS
    showAllOpenings: false,

    show0Players: 'true',
    show1Player: false,
    show2Players: false,
    show3Players: false,
    show4Players: false,

    audioDisabled: false,  // true if audio is disabled
    audioClips: ['desk bell', 'tolling bell', 'trumpet', 'rooster'],    // ADD TO SETTINGS

  }),

  computed: {

    tF () {
      return numericTime(this.range0)
    },
    tF2 () {
      return numericTime(this.range1)
    },

    playAudioComputed () {
      // if there are any openings, perform notifications as specified in setttings
      if (this.actualOpenings.length>0) {
        this.playAudio()
                        //alert("playAudioComputed "+this.$store.getters.selectedDate)
        this.sendSMS("")
      }
      return ""
    },

    XXteeSheetDateComputed () {
      if (this.$store.state.sniffing===undefined) return ""
      if (this.$store.state.sniffing.teeSheetDate===undefined) return ""
      return this.$store.state.sniffing.teeSheetDate
    },

    actualOpenings () {
        return this.filteredOpenings.filter(function (e) {
                    return e.players == 0
                });
    },

    filteredOpenings () {
      console.log("called filteredOpenings ",this.show0Players,this.sp1,this.sp2,this.sp3,this.sp4)
      let res = []
      res.length = 0
      const tF  = numericTime(this.range0)
      const tF2 = numericTime(this.range1)
          //const courseFilter = this.$store.state.sniffing.courseFilter
      const courseFilter = this.selectedCoursesStr
          //console.log("tF, cF",tF,tF2, courseFilter)
      const d = "d"+this.$store.getters.selectedDate2
            console.log("teeSheets",this.$store.state.teeSheets)
            console.log("sniffing.teeSheetDates2 ",this.$store.state.sniffing.teeSheetDates2)
            console.log("d",d)
            console.log("state",this.$store.state)
      const opens = this.$store.state.teeSheets[d].openings
            console.log("opens",opens.length,opens)
            console.log("res0",res)

      for (let i=0; i<opens.length; i++) {
        let op = opens[i]
            //console.log("op",op)
        let tt = numericTime(op.time)
        // filter if tee time is not within the selected range
        if (!isTimeSelected(tt, tF, tF2)) continue
        // filter if the course is not selected
        if (!isCourseSelected(op.course, courseFilter)) continue
        // filter singles, twosomes, and/or threesomes

        if (!isPlayersSelected(this.show0Players,this.sp1,this.sp2,this.sp3,this.sp4, op.players)) continue
            console.log("push",i,op.players,op)
            console.log("called filteredOpenings "+this.sp0+this.sp1+this.sp2+this.sp3+this.sp3)

        res.push(op)
      }
          console.log("res1",res)

      return res
    },


    sp0 () {
      return this.show0Players
    },
    sp1 () {
      console.log("sp1",this.show1Player)
      return this.show1Player
    },
    sp2 () {
      return this.show2Players
    },
    sp3 () {
      return this.show3Players
    },
    sp4 () {
      return this.show4Players
    },


    selectedCoursesStr () {
      return this.selectedCourses.join(" ")
    },

    range0 () {
      return sliderToChelseaTime(this.range[0])
      //return sliderToNumericTime(this.range[0])
    },
    range1 () {
      return sliderToChelseaTime(this.range[1])
      //return sliderToNumericTime(this.range[1])
    },

    sniffDateTime () {
      if (this.$store.state.sniffing!=undefined) {
        let s = this.$store.state
        s.temp = ""
        const d = this.$store.state.sniffing.sniffed
        return new Date(d)
      }
      else return ""
    },

    timestamp () {
      return getTimestamp()
    },

    anyPlayers () {
      let count = 0;
      if (this.openings===undefined) return 0
      for (let i=0;i<this.openings.length;i++) {
        count += this.openings[i].players
      }
      return count
    },

  },

  watch: {

    sniffFromStore: function () {
      if (this.$store.state.sniffing!=undefined) {
        const d = this.$store.state.sniffing.sniffed
        this.sniffDT = new Date(d)
      }
      else this.sniffDT =  ""
    },

    XclearChangeUI: function () {
      alert("IN DEVELOPMENT: will now remove the red outlines and grayed tee times, and show just the current tee sheet.")
      this.alert =  false
    },

  },

  methods: {

    shortenDate (d) {
        // February 11, 2020 - Tuesday   ==> Feb 11 - Tue
        const i = d.indexOf(" ")
        const j = d.indexOf("-")
        let s = ""
        s += d.substring(0,3)+d.substring(i,i+3)
        s += d.substring(j-1,j+5)
        return s
    },

    //
    // this actually sends the SMS message to notify of openings
    //
    sendSMS: function(prefix) {
          // don't send SMS unless setting parameters is set to true
          if ( !this.$store.state.settings.showTextMessages ) return

          // don't send within 10 seconds of last one, unless it's a test
          if (this.lastSMStimestamp>0 && (getTimestamp()-this.lastSMStimestamp) < 6000) return
          this.lastSMStimestamp = getTimestamp()

          let url = "https://us-central1-golf-ee7a0.cloudfunctions.net/sendText?text="
          url += prefix
          url += this.actualOpenings.length + " Open"
          url += ' per Chelsea Cyber Crawler on';

          // if phone number is not specified, send to default phone #
          if ( !this.$store.state.settings.textMessagePhone ) {
              url += "&to=" + "6177337927" ;
          }
          else {
              url += "&to=" + this.$store.state.settings.textMessagePhone ;
          }

          url += "&d="+ Date();
          console.warn("BINGO: calling sendSMS with query="+url)

          this.$http.get(url)
            .then((response) => {
              console.log(response.data);
              console.log(response.status);
              console.log(response.statusText);
              console.log(response.headers);
              console.log(response.config);
              //alert("called sendSMS "+response.statusText)
            });

            // axios.get('https://us-central1-golf-ee7a0.cloudfunctions.net/sendText?text=d9')
            //const href='"https://us-central1-golf-ee7a0.cloudfunctions.net/sendText?text=d9" target="_sms"'
            //window.location = href
    },

    testSMS: function() {
      this.sendSMS("TEST SMS: ");
      //alert( "message going to " + this.$store.state.settings.textMessagePhone )
    },

    changeOpeningsPlayers: function() {
      //this.$forceUpdate();
    },

    playersToggle: function() {
            this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"show123Players","value":!this.$store.state.settings.show123Players} )
    },

    clearChanges: function() {
      this.alert = true
          //alert("This will clear the change indications, and delete the tee times no longer available")
      this.$store.dispatch('setOpeningsPrior') // save the current openings as the Prior ones
    },

    clearChangeUI: function () {
      alert("IN DEVELOPMENT: will now remove the red outlines and grayed tee times, and show just the current tee sheet.")
      this.alert =  false
      this.showDiffs = false
      this.$store.dispatch('setShowDiffs',false) // expect messages
    },

    // prepares a string to show the tee sheet detail for this opening
    hoverOpening: function(item) {
      let str = ""
      if (item.diff=="+") str += "<span class='cAdded2'>Tee Time is now AVAILABLE.</span> "
      if (item.diff=="-") str += "Tee Time was recently BOOKED. "
      if (item.players>0) {
        str += item.players+" players: "
        if (item.captain) str += item.captain
        if (item.player2) str += ", "+item.player2
        if (item.player3) str += ", "+item.player3
        if (item.player4) str += ", "+item.player4
      }
      return str
    },
    mouseOver: function(index){
        this.active = !this.active  
            //console.log(index, this.filteredOpenings[index].course+" "+this.filteredOpenings[index].hole)
        this.activeItem = index   // cache the index in this variable
        return this.filteredOpenings[index]
    },
    mouseOut: function(){
        this.active = !this.active;  
    },

    // this actually plays the audio message to notify of openings
    playAudio: function () {
      if ( !this.$store.state.settings.showDiffsViaAudio || this.audioDisabled ) return

      // need to hard code these since the webpack require doesn't allow dynamic paths
      // format of the audio call is:     
      // const sound = ( new Audio( require('@/assets/foo.ogg') ).play();

      let audio
      if (this.$store.state.settings.audioClipSelected=='rooster') {
            audio = new Audio(require('./Rudy_rooster_crowing-Shelley-1948282641.mp3'))
      }
      else if (this.$store.state.settings.audioClipSelected=='tolling bell') {
            audio = new Audio(require('./tolling-bell_daniel-simion.mp3'))
      }
      else if (this.$store.state.settings.audioClipSelected=='desk bell') {
            audio = new Audio(require('./front-desk-bells-daniel_simon.mp3'))
      }
      else if (this.$store.state.settings.audioClipSelected=='trumpet') {
            audio = new Audio(require('./Trumpet-sound.mp3'))
      }
      console.warn("BINGO: playing audio="+this.$store.state.settings.audioClipSelected)
      audio.play()
    },

    audioOff: function () {
      this.audioDisabled = true
    },
    audioOn: function () {
      this.audioDisabled = false
      this.playAudio()
    },

    classObject3: function (item) {
          //console.log("classObject",course)
      if (item===undefined) return ""
      //if (item.diff=='+')
      let s = ""
      const course = item.course
      if(course=="South") s += ' cSouth' 
      if(course=="North") s += ' cNorth' 
      if(course=="Desert") s += ' cDesert' 
      if(course=="Cimarron") s += ' cCimarron' 

      if (this.showDiffs) {
          if (item.diff!=undefined) {
            if (item.diff=="+") s += " cAdded "
            if (item.diff=="-") s += " cDeleted "
          }
      }
      // highlight Lady's events
      if (item.captain.indexOf("Ladies")>=0) s += " cLadies "
      if (item.captain.indexOf("Lady")>=0) s += " cLadies "
      // highlight fully open times
      if (item.players==0) s += " cOpen "
      // highlight closed times
      if (item.captain.indexOf("Closed")>=0) s += " cClosed "


      let myPlayerCount = 0;
      for (let j=0; j<this.myPlayerNames.length; j++) {
            if (item.captain.indexOf(this.myPlayerNames[j])>=0) myPlayerCount++
            if (item.player2.indexOf(this.myPlayerNames[j])>=0) myPlayerCount++
            if (item.player3.indexOf(this.myPlayerNames[j])>=0) myPlayerCount++
            if (item.player4.indexOf(this.myPlayerNames[j])>=0) myPlayerCount++
      }

        if (myPlayerCount>=4) {
          s += " cMyGroup4 "
        }
        else if (myPlayerCount>=3) {
          s += " cMyGroup3 "
        }
        else if (myPlayerCount>=2) {
          s += " cMyGroup2 "
        }
        else if (myPlayerCount>=1) {
          s += " cMyGroup1 "
        }

      return s
    },

    audioOnClass: function () {
      if (this.audioDisabled) return ""
      return "outlined"
    },
    audioOffClass: function () {
      if (this.audioDisabled) return " outlined"
      return ""
    },

    sniffMethod: function () {
      if (this.$store.state.sniffing!=undefined) {
        const d = this.$store.state.sniffing.sniffed
        return getCorrectString(d)
      }
      else return ""
    },

    reverseArray: function (arr) {
        return arr.reverse()
    },
    blankIfUndef: function (str) {
        if (str!=undefined) return str
        return ""
    },
    blankIfZero: function (num) {
        if (num===undefined) return ""
        if (num==0) return ""
        return num
    },
    anyPlayersMethod: function () {
      let count = 0;
      if (this.openings===undefined) return 0
      for (let i=0;i<this.openings.length;i++) {
        count += this.openings[i].players
      }
      return count
    },

    abbrev: function (str) {
        return str.substring(0,1)
    },
    shortTime: function (str) {
        let s = str.substring(0,5)
        if (s.charAt(0)=="0") s=s.substring(1,5)
        return s
    },
  },
}

function isPlayersSelected(sp0,sp1,sp2,sp3,sp4,players) { 
    if ( (sp0==true||sp0=='true') && players==0) return true
    if (sp1=='true' && players==1) return true
    if (sp2=='true' && players==2) return true
    if (sp3=='true' && players==3) return true
    if (sp4=='true' && players==4) return true // should an object with 4 players appear, let's see it 
    return false
}

function isCourseSelected(course, courseFilter) { 
            if (courseFilter) {
                if (courseFilter.indexOf(course)==-1) return false;
                return true;
            }  
            else return true;
}

//
// true if   tF <= tt <= tF2
//
function isTimeSelected(tt, tF, tF2) { 
    if (tF2==0) {
        return (tt==tF)   // simple comparison of exact time
    }
    // 2nd time is specfied, so treat the times as a range
    else {
        if (tt<tF) return false;    // too early
        if (tt>tF2) return false;   // too late
        return true;
    }
}

// takes a number from 0 to 72 and returns a time from 08:00 AM to 05:00 PM in 7 to 8 minute increments
function sliderToChelseaTime(val) {
  return chelseaTime(sliderToNumericTime(val));
}
// takes a number from 0 to 72 and returns a time from 800 to 1700 in 7 to 8 minute increments
function sliderToNumericTime(val) {
  const h = Math.floor(val/8);
  const remainder = val - 8*h;
  const m = [0,7,15,22,30,37,45,52];
  //let x = (h+7)*100 + m[remainder]    // for 7am to 5pm
  let x = (h+8)*100 + m[remainder]      // for 8am to 5pm
  return x;
}
// takes a number in military time (eg 1315) and returns Chelsea format ( 01:15 PM )
function chelseaTime(numericTime) {
  let ap = "";
  let t = numericTime;
  if (numericTime>=1200) {
    t = t-1200;
  }
  if (numericTime>=1200) {
    ap = " PM";
  }
  else {
    ap += " AM";
  }
  let s
  if (numericTime>=1200 && numericTime<=1259) {
    s = String(t+1200);
  }
  else {
    s = String(t);
  }
  if (s.length<4) s = "0"+s;
  s = s.substring(0,2) + ":" + s.substring(2,4);
  s = s + ap;
    //console.log("chelseaTime",s)
  return s;
}

// chelsea time has format 02:15 PM
// convert to 1415
function numericTime(chelseaTime) {
    if (chelseaTime===undefined || chelseaTime=="" || chelseaTime==null ) return 0
    const h = chelseaTime.substring(0,2);
    const m = chelseaTime.substring(3,5);
    const ap = chelseaTime.substring(6,8);
    let t = Number(h*100) + Number(m);
    if (ap.toUpperCase()=="PM" && h!="12") t+=1200;
    return t;
}

function getCorrectString(dateTimeString){
     var a  = new Date(dateTimeString);
     return ('00'+(a.getMonth()+1)).substring(('00'+(a.getMonth()+1)).length-2) +'/'
        +('00'+a.getDate()).substring(('00'+a.getDate()).length-2)+' '
        +a.getFullYear()+' '
        +('00'+a.getHours()).substring(('00'+a.getHours()).length-2)+':'
        +('00'+a.getMinutes()).substring(('00'+a.getMinutes()).length-2)+':'
        +('00'+a.getSeconds()).substring(('00'+a.getSeconds()).length-2);
}

function getTimestamp() {
  return Number(new Date());
}

/*
//
// Simpler version that plays just 1 mp3
//
// preload audio?   http://www.oddcast.com/support/loadAudio.html
// 
//
function playSound(path,volumePercent) {

	console.log("called playSound",path,volumePercent+"%");	
    //console.log("playSound caller is " + arguments.callee.caller.toString());

 // path/audiofile.mp3
  if (volumePercent===undefined) volumePercent=50;  // default to full volume; 
  var audioElement = document.createElement('audio');
  audioElement.volume = volumePercent/100;  
  //audioElement.setAttribute('autoplay', true);
  audioElement.setAttribute('src', path);
  audioElement.play();  // do not need this as autoplay will cause it to play as soon as loaded
}
*/

</script>

<style scoped>

  .holeCard {
    border: solid 1px;
    padding: 3px;
    color: white;
    width: 40px;
    background-color: lightGray;
  }

  /* styles for the various courses */
  .cNorth {
      background-color: green;
  }
  .cSouth {
      background-color: yellowgreen;
  }
  .cDesert {
      background-color: goldenrod;
  }
  .cCimarron {
      background-color: dodgerblue;
  }
  .cDeleted {
      background-color: lightGray;
  }
  .cAdded {
    /* border: 1px solid red; */
    animation: blink 5s linear infinite;
    outline: 3px solid red;
    outline-offset: -4px;
  }
  .cAdded2 {
    color: red;
  }
  .cLadies {
    outline: 4px dotted pink;
    outline-offset: -5px;
  }
  .cOpen {
    animation: steady 22s linear infinite;
    /*
    outline: 2px solid red;
    outline-offset: -3px;
    */
    border-radius: 50%;  /* creates a circular image for open tee-times */   
  }
  .cClosed {
    animation: steady 22s linear infinite;
    /*     */
    outline: 3px double red;
    outline-offset: -4px;
    /* border-radius: 40%;  creates a circular image for open tee-times */   
  }


  .cMyGroup4 {
    animation: blink 5s linear infinite;
    outline: 4px solid navy;
    outline-offset: -5px;
  }
  .cMyGroup3 {
    animation: blink 5s linear infinite;
    outline: 4px dashed navy;
    outline-offset: -5px;
  }
  .cMyGroup2 {
    animation: blink 5s linear infinite;
    outline: 3px dashed navy;
    outline-offset: -4px;
  }
  .cMyGroup1 {
    animation: blink 5s linear infinite;
    outline: 2px dotted navy;
    outline-offset: -3px;
  }

  @keyframes blink{
    0%{opacity: .5;}
    25%{opacity: .8;}
    50%{opacity: 1;}
    75%{opacity: .8;}
    100%{opacity: .5;}
  }
  @keyframes steady{
    0%{opacity: .8;}
    50%{opacity: .8;}
    100%{opacity: .8;}
  }

  /* https://codepen.io/kocsten/pen/eYOKZVp */

  .players {
    color: red;
  }

  .flex-empty {
    height: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    
    div {
      width: 150px;
    }
  }
  .flex {
    flex-grow: 0;
  }
  .outlined {
    border: 1px solid;
  }

  .show-btns {
  color: rgba(255, 255, 255, 1) !important;
  }

  .hoverOpening:hover{
    border: 1px solid gray;
    cursor: pointer;
    color: #eee;
  }
  .noBullet {
      list-style-type: none;
  }
  .tLarger {
    font-size: 150%;
  }
  .tLarger2 {
    font-size: 200%;
  }
</style>